import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="m18.83 2.89-.923.739s1.21 1.532 1.153 2.748c-1.556 0-2.767 1.162-2.767 2.536s1.268 2.537 2.767 2.537S22 10.287 22 8.86c0-.052-.23-3.857-3.17-5.97M11.22 2.89l-.922.739s1.21 1.532 1.153 2.748c-1.557 0-2.767 1.162-2.767 2.536s1.268 2.537 2.767 2.537 2.94-1.163 2.94-2.59c0-.052-.23-3.857-3.17-5.97"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M8.684 5.267c-3.072.058-4.936.314-5.29.718-.473.576-.414 4.667-.355 6.683 0 .749.591 1.383 1.3 1.498.472.058 4.843-.23 2.894-2.42-1.89-2.19-5.434 3.284.355 3.745M9.832 16.701l3.072.058s3.426 4.321 3.485 3.284.177-3.4.177-3.4 3.19.289 3.367-.057c.059-.115.177-1.498.236-3.227"
    />
  </svg>
);
export const QuoteBubbleIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
